import React, { useState, useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import HPageContainer from "../../../hcomponents/HPageContainer";
import HHeader from "../../../hcomponents/HHeader";
import HActionButton from "../../../hcomponents/HActionButton";
import { Plus } from "lucide-react";
import ViewToggle from "../../../components/ViewToggle";
import HostSpaces from "../host-spaces";

// Hardcoded tabs with fixed categoryIds: Work=1, Stay=2, Play=3
const STATIC_TABS = [
  { id: "work", label: "Work", categoryId: 1 },
  { id: "stay", label: "Stay", categoryId: 2 },
  { id: "play", label: "Play", categoryId: 3 },
];

const AllSpaces = () => {
  const history = useHistory();
  const location = useLocation();
  const isUpdatingUrl = useRef(false);

  // Get active tab from URL query param
  const queryParams = new URLSearchParams(location.search);
  const urlTab = queryParams.get("type") || "work";
  const [activeTab, setActiveTab] = useState(urlTab);
  const tabs = STATIC_TABS; // Use hardcoded tabs, no API fetch

  // Handle tab change
  const handleTabChange = newTab => {
    if (newTab === activeTab) return;

    isUpdatingUrl.current = true;
    setActiveTab(newTab);

    const params = new URLSearchParams(location.search);
    params.set("type", newTab);
    history.replace({ search: params.toString() });

    setTimeout(() => {
      isUpdatingUrl.current = false;
    }, 100);
  };

  // Sync URL changes to active tab (only for external changes like browser back/forward)
  useEffect(() => {
    if (isUpdatingUrl.current) return;

    const params = new URLSearchParams(location.search);
    const urlType = params.get("type") || "work";

    if (urlType !== activeTab && tabs.find(t => t.id === urlType)) {
      setActiveTab(urlType);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]); // Remove activeTab from dependencies to prevent loop

  const handleCreateNew = () => {
    if (activeTab === "play") {
      history.push(`/host/play-services/create`);
      return;
    }
    // For work and stay, use the correct route from App.jsx
    history.push(`/host/add-space?type=${activeTab}`);
  };

  const activeTabData = tabs.find(t => t.id === activeTab);

  return (
    <>
      <HPageContainer>
        <HHeader
          rightButton={
            <HActionButton
              icon={<Plus className="w-4 h-4" />}
              label={activeTab === "play" ? "Create Play Service" : `Add ${activeTabData?.label} Space`}
              onClick={handleCreateNew}
              className="text-xs md:text-sm"
            />
          }
        />

        <div className="px-3 sm:px-4 md:px-6 lg:px-8 pt-4">
          {/* Category Tabs */}
          <div className="mb-2">
            <div className="inline-flex">
              <ViewToggle
                options={tabs.map(t => ({ value: t.id, label: t.label }))}
                value={activeTab}
                onChange={handleTabChange}
                size="md"
                className=""
              />
            </div>
          </div>
        </div>

        {/* Content Area - Removed overflow-auto from parent to let HostSpaces handle its own scrolling */}
        <div className="flex-1 min-h-0">
          <HostSpaces categoryId={activeTabData?.categoryId} showHeader={false} />
        </div>
      </HPageContainer>
    </>
  );
};

export default AllSpaces;
